import React from 'react';
import { Grid, Box, IconButton } from '@mui/material';
import {
    LinkedIn as LinkedInIcon,
    Instagram as InstagramIcon,
    Email as EmailIcon,
    Store as YelpIcon,
} from '@mui/icons-material';

const ProfileSocials: React.FC = () => {
    return (
        <Grid item xs={12}>
            <Box sx={{ display: 'flex', gap: 2, mt: 2, justifyContent: 'center' }}>
                <IconButton href="https://www.linkedin.com/" target="_blank" color="primary">
                    <LinkedInIcon />
                </IconButton>
                <IconButton href="https://www.instagram.com/" target="_blank" color="secondary">
                    <InstagramIcon />
                </IconButton>
                <IconButton href="mailto:email@example.com" color="default">
                    <EmailIcon />
                </IconButton>
                <IconButton href="https://www.yelp.com/" target="_blank" color="error">
                    <YelpIcon />
                </IconButton>
            </Box>
        </Grid>
    );
};

export default ProfileSocials;
